import { render, staticRenderFns } from "./JunkPage.vue?vue&type=template&id=23773cdc"
import script from "./JunkPage.vue?vue&type=script&lang=js"
export * from "./JunkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports